import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';
import moment from 'moment';

const getRequestsHouse = async ({
  houseId,
  addressStageRequest,
  targetDate,
}) => {
  return await request.get(
    `HousingStock/house/${houseId}/requests`,
    {
      addressStageRequest,
      ...(!!targetDate && {
        targetDate: moment(targetDate).format('YYYY.MM.DD'),
      }),
    },
    'При получении заявок произошла ошибка'
  );
};

const useRequestsHouse = (value, options) =>
  useQuery(
    getQueryKeys.houseRequests(value),
    () => getRequestsHouse(value),
    options
  );

export default useRequestsHouse;
